export default "__VITE_PUBLIC_ASSET__5a777f8d__"